module.exports = __webpack_public_path__ + "img/produzidas-trilha-dashboard.a9a0438d.svg";